import React, { useState, useEffect } from "react"
import { useLocation } from "@reach/router"
import GrillaEvento from "./grillaEvento"

const ListadoScreen = ({ eventosData, variablesEntorno }) => {
  const location = useLocation()

  const [state, setState] = useState({
    eventos: [...eventosData],
    filtradoXArea: [],
    gruposMostrados: 1,
    searchText: "",
  })

  const [apiUrl, setApiUrl] = useState("")

  useEffect(() => {
    // Si hay query string en la URL, la usamos para filtrar los eventos
    const rawQuery = location && location.search ? location.search.replace(/^\?/, "") : ""

    if (!rawQuery) {
      setApiUrl("")
      setState(s => ({ ...s, eventos: [...eventosData] }))
      return
    }

    // Construir la URL "API" mostrada al usuario (preserva el separador ; si estaba en la URL)
    const builtApiUrl = `${variablesEntorno.AGENDA_APP_SITE}/home/?${rawQuery}`
    setApiUrl(builtApiUrl)

    // Parseo sencillo del querystring (no dependemos de URLSearchParams para preservar ;) )
    const paramsObj = {}
    rawQuery.split("&").forEach(pair => {
      const [rawK, rawV] = pair.split("=")
      if (!rawK || !rawV) return
      const k = decodeURIComponent(rawK)
      const v = decodeURIComponent(rawV)
      paramsObj[k] = v
    })

    const applyFilters = (events, params) => {
      let filtered = [...events]

      Object.keys(params).forEach(key => {
        const rawVal = params[key]
        const values = rawVal
          .split(";")
          .map(v => v.trim().toLowerCase())
          .filter(Boolean)

        if (values.length === 0) return

        filtered = filtered.filter(ev => {
          // filtro por tipo
          if (key.toLowerCase() === "tipo") {
            const nombre = ev.tipo_evento?.Nombre?.toLowerCase() || ""
            return values.includes(nombre)
          }

          // filtro por area
          if (key.toLowerCase() === "area") {
            const areaNames = (ev.area_tematicas || []).map(a => (a.Nombre || "").toLowerCase())
            return areaNames.some(n => values.includes(n))
          }

          // fallback: buscar en título, tipo y áreas
          const titulo = (ev.Titulo || "").toLowerCase()
          if (values.some(v => titulo.includes(v))) return true

          if (ev.tipo_evento && values.includes((ev.tipo_evento.Nombre || "").toLowerCase())) return true

          if (ev.area_tematicas && ev.area_tematicas.some(a => values.includes((a.Nombre || "").toLowerCase()))) return true

          return false
        })
      })

      return filtered
    }

    const filteredResult = applyFilters(eventosData, paramsObj)
    setState(s => ({ ...s, eventos: filteredResult }))
  }, [location.search, eventosData, variablesEntorno])

  return (
    <>
      <div className="section-events">
        <div className="container-1200 w-container">
          <div className="head-title-search">
            <h1 className="h2-title-home">Listado de eventos</h1>
            <p>Se muestran {state.eventos.length} actividades</p>
            {/* {apiUrl && (
              <p>
                API generada:{" "}
                <a href={apiUrl} target="_blank" rel="noopener noreferrer">
                  {apiUrl}
                </a>
              </p>
            )} */}
          </div>

          <GrillaEvento
            state={state}
            setState={setState}
            variablesEntorno={variablesEntorno}
          />
        </div>
      </div>
    </>
  )
}

export default ListadoScreen
